import { Injectable } from '@angular/core';
import { LoginCustomization } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Subject } from 'rxjs';
import { SlugService } from '../../../../../core/services/slug.service';

@Injectable({
  providedIn: 'root'
})
export class LoginCustomizationService {
  constructor(private readonly apollo: Apollo, private readonly slugService: SlugService) { }

  public readonly refreshLoginCustomization = new Subject<void>();

  async save(input: any): Promise<void> {
    await this.apollo.mutate({
      mutation: gql`
          mutation updateLoginCustomization($input: LoginCustomizationInput) {
            updateLoginCustomization(input: $input) {
              logoUrl
            }
          }
        `,
      variables: {
        input
      }
    }).toPromise();
  }

  async loginCustomizationBySlug(): Promise<LoginCustomization> {
    return this.apollo.query({
      query: gql`
        query loginCustomization($slug: String!){
          loginCustomization(slug: $slug) {
            accountName
            description
            logoUrl
            color {
              class
              background
              foreground
            }
            clientId
            tenantId
            openIdConfigurationEndpoint
          }
        }
      `,
      variables: {
        slug: this.slugService.getSlug()
      }
    }).toPromise()
      .then((result: any) => result.data.loginCustomization);
  }

  async getLoginCustomizationFromCurrentUser(): Promise<any> {
    return this.apollo.query({
      query: gql`
        query loginCustomizationByCurrentUser {
          me {
            account {
              loginCustomization {
                description
                logoUrl
                color {
                  class
                  background
                  foreground
                }
                clientId
                tenantId
                openIdConfigurationEndpoint
              }
            }
          }
      }`
    }).toPromise()
      .then((result: any) => result.data.me.account.loginCustomization);
  }

}
